import {
    LOAD_ONBOARDING_PROGRESS,
    FETCH_ONBOARDING_PROGRESS
} from '../actions/onboarding'

const initialState = {
    steps: [],
    completedCount: 0,
    totalCount: 5,
    percentage: 0,
    isComplete: false,
    loading: true
}

const onboardingReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ONBOARDING_PROGRESS:
            return {
                ...state,
                loading: true
            }
        case LOAD_ONBOARDING_PROGRESS:
            return {
                ...state,
                ...action.payload,
                loading: false
            }
        default:
            return state
    }
}

export default onboardingReducer
